import api from './api';

export const fetchServicePages = async () => {
  const response = await api.get('/admin/service-pages');
  return Array.isArray(response.data) ? response.data : [];
};

export const updateServicePage = async (id, data) => {
  const response = await api.put(`/admin/service-pages/${id}`, data);
  return response.data;
};

export const createServiceVariation = async (servicePageId, data) => {
  const response = await api.post(`/admin/service-pages/${servicePageId}/variations`, data);
  return response.data;
};

export const updateServiceVariation = async (id, data) => {
  const response = await api.put(`/admin/service-variations/${id}`, data);
  return response.data;
};

export const deleteServiceVariation = async (id) => {
  const response = await api.delete(`/admin/service-variations/${id}`);
  return response.data;
};
